/* eslint-disable import/order */
import React from 'react';
import compose from 'utils/helper-functions/compose';
import { withI18N } from 'shared-components/hoc-components';
import './error-page.sass';
import { withRouter } from 'react-router';
import { shallowEqual, useSelector } from 'react-redux';
import Button from '@pano-project/components/Button/Button';
import { clientClickEvent } from 'utils/custom-cashier-events/client-click-event';
import IconArrow from '@pano-project/assets/icons/IconArrow';
import IconFailed from '@pano-project/assets/icons/IconFailed';
import { ReactComponent as IconFailedFirst } from '@pano-project/assets/icons/transaction-icons/failedIcon.svg';
import MainLayout from '@pano-project/components/Layout/MainLayout/MainLayout';
import { useHeaderConfig } from '@pano-project/components/CashierHeader/HeaderContext';

const ErrorPage = (props) => {
  const { wrapper = false, errorsInfo, langBack, history } = props;

  return (
    <>
      {wrapper ? (
        <MainLayout page="errorPage">
          <ErrorPageContent
            errorsInfo={errorsInfo}
            langBack={langBack}
            history={history}
            isFatal={true}
          />
        </MainLayout>
      ) : (
        <ErrorPageContent errorsInfo={errorsInfo} langBack={langBack} history={history} />
      )}
    </>
  );
};

const ErrorPageContent = ({ errorsInfo, langBack, history, isFatal = false }) => {
  const {
    errorType,
    back = false,
    submit_action = '',
    submit_name = '',
    generateErrorMessage,
  } = errorsInfo;
  const { layout, policies_data } = useSelector(
    ({
      initTheme: {
        theme_editor_settings: { customization_settings: { layout, policies_data } = {} } = {},
      },
    }) => ({ layout, policies_data }),
    shallowEqual,
  );
  const isAmountFirstLayout = layout === 'amount-first';
  const supportLink =
    policies_data?.support_website ||
    (policies_data?.support_email ? `mailto:${policies_data.support_email}` : '#');

  useHeaderConfig(
    isFatal
      ? { variant: 'top-bar', showBack: false, className: 'main-header--reduced' }
      : undefined,
    [isFatal],
  );

  const errors = {
    1: {
      title: 'Payment method not available.',
      description: 'Please contact your site administrator.',
      message: 'Payment method not available. Please contact your site administrator.',
    },
    2: {
      title: 'Token is invalid',
      description: '',
      message: 'Token is invalid',
    },
    3: {
      title: 'Not available gateways found',
      description: 'Not available gateways found',
      message: 'Not available gateways found',
    },
    4: {
      title: 'Not supported yet',
      description: 'Not supported yet',
      message: 'Not supported yet',
    },
    5: {
      title: 'Something went wrong.',
      description:
        "Apologies, it appears that you don't have any payment details registered to use for withdrawal request",
      message:
        "Apologies, it appears that you don't have any payment details registered to use for withdrawal request",
    },
    6: {
      title: 'Unknown session',
      description: '',
      message: 'Unknown session',
    },
    7: {
      title: 'Session expired',
      description: isAmountFirstLayout
        ? 'Your session has expired. Please try again by starting over.'
        : '',
      message: 'Session expired',
    },
    8: {
      title: 'Something went wrong.',
      description: 'Please contact your system administrator (Code: 101)',
      message: 'Something went wrong. Please contact your system administrator (Code: 101)',
    },
    9: {
      title: 'Something went wrong.',
      description:
        'For the combination of card number, amount and currency there are no available payment gateways. Please try another credit card or select an alternative payment method.',
      message:
        'For the combination of card number, amount and currency there are no available payment gateways. Please try another credit card or select an alternative payment method.',
    },
    10: {
      title: "Can't get session information",
      description: '',
      message: "Can't get session information",
    },
  };

  const errorsTitle = Object.keys(errors)?.reduce((acc, errorType) => {
    acc[errorType] = errors[errorType]?.title;
    return acc;
  }, {});

  return (
    <div className={'page-container error-container'}>
      <div className={'error-back-button'}>
        {errorType && back ? (
          <div
            className={'back'}
            onClick={() => {
              clientClickEvent('back_button');
              history.push('gateways');
            }}
            aria-label={langBack('All Payment Methods')}
          >
            <IconArrow />
            {!isAmountFirstLayout && ` ${langBack('All Payment Methods')}`}
          </div>
        ) : (
          ''
        )}
      </div>
      <div className={`error-page ${errorType ? 'error-' + errorType : ''}`}>
        <div className={'error-icon'}>
          {isAmountFirstLayout ? <IconFailedFirst /> : <IconFailed />}
        </div>
        <div className={'title'}>{generateErrorMessage(errorsTitle, errorType)}</div>
        {isAmountFirstLayout ? (
          <>
            <div className={'description'}>
              {errors[errorType]?.description && <p>{langBack(errors[errorType]?.description)}</p>}
              <div className={'need-help'}>
                <span className={'need-help-label'}>{langBack('Need help?')}</span>{' '}
                <a
                  href={supportLink}
                  className={'need-help-link'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {langBack('Contact Support')}
                </a>
              </div>
            </div>
            <div className={'error-page-bottom'}>
              <Button
                type="button"
                variant="fourfold"
                sizeType="medium"
                className="amount-first-go-back-button"
                onClick={() => {
                  clientClickEvent('back_button');
                  history.push('gateways');
                }}
              >
                {langBack('go-back')}
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className={'description'}>
              {errors[errorType]?.description && <p>{langBack(errors[errorType]?.description)}</p>}
              {langBack(
                'If you require assistance or technical support, please contact customer support.',
              )}
            </div>
            {!submit_action ? (
              ''
            ) : (
              <a href={submit_action} onClick={() => clientClickEvent('back_to_website_button')}>
                <Button variant="fourfold" className={'button'}>
                  {submit_name}
                </Button>
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default compose(withRouter, withI18N)(ErrorPage);
